var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiveLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 96,
    viewBox: "0 0 154 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6498 0H84.7356L106.724 22.5882H24.59V36.3922L126.773 35.7647C149.02 36.7686 153.72 55.8431 153.289 65.2549C152.771 88.8471 135.396 95.5817 126.773 96H60.8067L38.818 73.4118H126.773V58.9804H22.6498C10.3621 58.3529 0.6612 54.5882 0.0144736 29.4902C-0.506771 9.26183 13.1645 1.46405 22.6498 0Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiveLogo);
export default __webpack_public_path__ + "static/media/five_logo.f05b6193db9ef43305a03d489d732c69.svg";
export { ForwardRef as ReactComponent };